import { render, staticRenderFns } from "./MessageForm.vue?vue&type=template&id=75df15ff&scoped=true&"
import script from "./MessageForm.vue?vue&type=script&lang=js&"
export * from "./MessageForm.vue?vue&type=script&lang=js&"
import style0 from "@/less/feedback.less?vue&type=style&index=0&id=75df15ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df15ff",
  null
  
)

export default component.exports